import { Stores } from '../pages/Stores/Stores';
import { AddEditSupplier } from '../pages/Suppliers/AddEditSupplier';
import { Suppliers } from '../pages/Suppliers/Suppliers';
import { Home } from '../pages/home/Home';
import { MasterPassword } from '../pages/master_password/MasterPassword';
import { Messages } from '../pages/messages/Messages';
import { Profile } from '../pages/Profile/Profile';
import { Products } from '../pages/Products/Products';
// import { ProductDetails } from '../pages/Products/ProductDetails';
import { StoreDetails } from '../pages/Stores/StoreDetails';
import { MessagesThread } from '../pages/messages/MessagesThread';

export const routesList: Array<Object> = [
  { path: '/', component: Home },
  { path: '/master-password', component: MasterPassword },
  { path: '/suppliers', component: Suppliers },
  { path: '/stores', component: Stores },
  { path: '/storeDetails', component: StoreDetails },
  { path: '/profile', component: Profile },
  { path: '/addEditSupplier', component: AddEditSupplier },
  { path: '/products', component: Products },
  // { path: '/productDetails', component: ProductDetails },
  { path: '/messages', component: Messages },
  { path: '/messagesThread', component: MessagesThread }
];
